import { useState, useCallback } from "react";
import axios from "axios";
import constant from "../utilities/constants.json";
import { useSetUnderMaintenance } from "./useMaintenanceStatus";
const API_URL = constant.server + "predict_multiple_games_answer";

/**
 * Custom hook to call predict_multiple_games_answer API
 * Handles loading & error internally, and accepts success/error callbacks.
 *
 * @returns {{
 *   predict: (data: object, options?: { onSuccess?: Function, onError?: Function }) => Promise<void>,
 *   loading: boolean,
 *   error: string | null
 *   isLoggedIn: boolean
 * }}
 */
export const usePredictMultipleAnswers = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(
    !!localStorage.getItem("webKey"),
  );
  const { setSiteUnderMaintenance } = useSetUnderMaintenance();

  const predict = useCallback(async (data, { onSuccess, onError } = {}) => {
    try {
      if (loading) return; // prevent multiple simultaneous calls

      if (!localStorage.webKey) {
        setIsLoggedIn(false);
        return;
      }

      const token = "Bearer " + localStorage.webKey;

      setLoading(true);
      setError(null);
      const response = await axios.post(
        API_URL,
        { answers: data },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
            time_zone: "Asia/Kolkata",
          },
        },
      );

      if (response.data.status === 1) {
        onSuccess?.(response.data); // callback if provided
      } else if (response.data.status === 103) {
        setSiteUnderMaintenance();
      } else if (response.data.status == 0 || response.data.status == 102) {
        localStorage.clear();
        return response;
      } else {
        const msg = response.data?.message || "Something went wrong.";
        setError(msg);
        onError?.(msg);
      }
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        err.message ||
        "Failed to submit predictions.";
      setError(msg);
      onError?.(msg);
    } finally {
      setLoading(false);
    }
  }, []);

  return { predict, loading, error, isLoggedIn };
};
